// actions/prescriptionActions.js
import axios from 'axios';
import {
  CREATE_PRESCRIPTION,
  CREATE_PRESCRIPTION_SUCCESS,
  CREATE_PRESCRIPTION_FAIL,
  GET_PRESCRIPTIONS,
  GET_PRESCRIPTIONS_SUCCESS,
  GET_PRESCRIPTIONS_FAIL,
  UPDATE_PRESCRIPTION,
  UPDATE_PRESCRIPTION_SUCCESS,
  UPDATE_PRESCRIPTION_FAIL,
  DELETE_PRESCRIPTION,
  DELETE_PRESCRIPTION_SUCCESS,
  DELETE_PRESCRIPTION_FAIL,
} from './types';

import { baseURL } from './types';

const API_URL = `${baseURL}/api/appointmentDoctorPrescription`;

// 🔐 Centralized Auth Headers
const getAuthHeaders = (isMultipart = false) => {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  if (!isMultipart) headers['Content-Type'] = 'application/json';
  return headers;
};

// ✅ Create Prescription
export const createPrescription = (formData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_PRESCRIPTION });

    const res = await axios.post(`${API_URL}/create`, formData, {
      headers: getAuthHeaders(true), // multipart/form-data
    });

    dispatch({ type: CREATE_PRESCRIPTION_SUCCESS, payload: res.data });
    
    return res.data; // ✅ RETURN this to use in component!
  } catch (error) {
    console.error('❌ createPrescription:', error.response?.data || error.message);
    dispatch({
      type: CREATE_PRESCRIPTION_FAIL,
      payload: error.message || 'Create prescription failed',
    });

    throw error; // ✅ Let component catch it
  }
};


// ✅ Get All Prescriptions
export const getAllPrescriptions = (hospitalID) => async (dispatch) => {
  try {
    dispatch({ type: GET_PRESCRIPTIONS });

    const res = await axios.post(`${API_URL}/getall`, {hospitalID}, {
      headers: getAuthHeaders(),
    });

    const data = Array.isArray(res.data?.data) ? res.data.data : [];

    dispatch({ type: GET_PRESCRIPTIONS_SUCCESS, payload: data });
  } catch (error) {
    console.error('❌ getAllPrescriptions:', error.message);
    dispatch({
      type: GET_PRESCRIPTIONS_FAIL,
      payload: error.message || 'Failed to fetch prescriptions',
    });
  }
};

// ✅ Update Prescription
export const updatePrescription = (formData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PRESCRIPTION });

    const res = await axios.patch(`${API_URL}/update`, formData, {
      headers: getAuthHeaders(true), // if formData contains file
    });

    dispatch({ type: UPDATE_PRESCRIPTION_SUCCESS, payload: res.data });
    return res.data;
  } catch (error) {
    console.error('❌ updatePrescription:', error.response?.data || error.message);
    dispatch({
      type: UPDATE_PRESCRIPTION_FAIL,
      payload: error.message || 'Update prescription failed',
    });
    throw error;
  }
};

// ✅ Delete Prescription (with ID in body)
export const deletePrescription = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PRESCRIPTION });

    await axios.delete(`${API_URL}/delete`, {
      headers: getAuthHeaders(),
      data: { id }, // DELETE with body
    });

    dispatch({ type: DELETE_PRESCRIPTION_SUCCESS, payload: id });
  } catch (error) {
    console.error('❌ deletePrescription:', error.response?.data || error.message);
    dispatch({
      type: DELETE_PRESCRIPTION_FAIL,
      payload: error.message || 'Delete prescription failed',
    });
  }
};
